import {useEffect, useState} from 'react'
import {Icon} from '../Icon';
import {MainContext, useContext} from 'mainContext'

function CurrentSong() {

	const {currentSong, methods, setMethods} = useContext(MainContext)

	const [coverSidebar, setCoverSidebar] = useState(false)

	useEffect(() => {
		setMethods({
			...methods,
			coverSidebar,
			setCoverSidebar,
		})
	}, [coverSidebar])

	return (
		<div className="flex gap-x-3 items-center" style={{minWidth: '180px', width: '30%'}}>
			{currentSong && (
				<>
					{!coverSidebar && (
						<div className="w-14 h-14 relative group">
							<button onClick={() => setCoverSidebar(true)}
							        className="absolute top-1 right-1 w-6 h-6 flex items-center bg-black bg-opacity-60 rounded-full justify-center z-[2] text-white text-opacity-70 transform hover:text-opacity-100 hover:scale-105 opacity-0 group-hover:opacity-100">
								<Icon src="arrowDown" size={20} className="transform -rotate-90"/>
							</button>
							{currentSong?.cover && (
								<img src={currentSong.cover}
								     className="w-full h-full object-cover"/>
							)}
							{!currentSong?.cover && (
								<div className="w-full h-full bg-white bg-opacity-10 flex items-center justify-center">
									<Icon src="music" size={40}/>
								</div>
							)}
						</div>
					)}
					<div>
						<a href="#" className="text-sm font-semibold">{currentSong.name}</a>
						<div style={{fontSize: '11px'}} className="text-white text-opacity-70 line-clamp-1">
							{currentSong.description}
						</div>
					</div>
					<div className="flex ml-2 gap-x-4">
						<button>
							<Icon src="hearthEmpty" size={16}
							      className="text-white text-opacity-70 hover:text-opacity-100"/>
						</button>
						<button>
							<Icon src="pip" size={16} className="text-white text-opacity-70 hover:text-opacity-100"/>
						</button>
					</div>
				</>
			)}
		</div>
	)
}

export default CurrentSong